import { styled } from "@mui/material/styles";
import RepeatIcon from "@mui/icons-material/Repeat";
import DeleteIcon from "@mui/icons-material/Delete";
import { CustomButton } from "@/shared/components";
import RestoreIcon from "@mui/icons-material/Restore";
import HlsIcon from "@mui/icons-material/Hls";

const Root = styled("div")({
  marginRight: "24px",
  display: "flex",
  alignItems: "center",
});

export interface CustomToolbarSelectProps {
  deleteButton?: any;
  repeatButton?: any;
  selectedRows: number[];
  restoreButton?: any;
  repeatFromHlsButton?: any;
  headButtons?: React.ReactNode;
  /** Заменяет весь набор кнопок над выбранными строками */
  selectableComponent?: React.ReactNode;
}

export const CustomToolbarSelect: React.FC<CustomToolbarSelectProps> = ({
  deleteButton,
  repeatButton,
  selectedRows,
  restoreButton,
  repeatFromHlsButton,
  headButtons,
  selectableComponent,
}) => {
  if (selectableComponent) {
    return <Root>{selectableComponent}</Root>;
  }

  return (
    <Root>
      {headButtons}
      {repeatFromHlsButton && (
        <CustomButton
          text="Repeat from hls"
          {...repeatFromHlsButton}
          icon={HlsIcon}
          onClick={() => {
            repeatFromHlsButton.onClick(selectedRows);
          }}
        />
      )}
      {repeatButton && (
        <CustomButton
          text="Repeat"
          {...repeatButton}
          icon={RepeatIcon}
          onClick={() => {
            repeatButton.onClick(selectedRows);
          }}
        />
      )}
      {restoreButton && (
        <CustomButton
          text="Restore"
          {...restoreButton}
          icon={RestoreIcon}
          onClick={() => {
            restoreButton.onClick(selectedRows);
          }}
        />
      )}
      {deleteButton && (
        <CustomButton
          text="Delete"
          {...deleteButton}
          icon={DeleteIcon}
          onClick={() => {
            deleteButton.onClick(selectedRows);
          }}
        />
      )}
    </Root>
  );
};
